import { cn } from '@listening/utils/react-helpers';
import { Button } from '@listening/frontend/components/radix/button';

export function ErrorComponent({
  header,
  message,
  promptRefresh = false,
  onRefresh,
  className,
}: {
  header: string;
  message?: string;
  promptRefresh?: boolean;
  onRefresh?: () => void;
  className?: string | undefined;
}) {
  return (
    <div
      className={cn(
        'mx-auto flex h-full max-w-[33rem] flex-col items-center justify-center',
        className,
      )}
    >
      <div className='flex w-full flex-col items-center justify-center'>
        <div className='line-clamp-1 text-center text-2xl font-bold'>
          {header}
        </div>
        {message && (
          <div className='line-clamp-2 w-full text-center text-lg whitespace-pre-line'>
            {message}
          </div>
        )}
      </div>
      {promptRefresh && (
        <Button
          className='mt-4 rounded-full bg-primary px-4 py-2 text-white'
          onClick={() => {
            if (onRefresh) {
              onRefresh();
              return;
            }
            window.location.href = '/app';
          }}
        >
          Refresh
        </Button>
      )}
    </div>
  );
}
